export default `@charset "UTF-8";
/* Ids Loading Indicator */
:host(ids-loading-indicator:not([linear]):not([sticky])) {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

:host(ids-loading-indicator:not([linear]):not([sticky]):not([inline])) {
  width: 50px;
  height: 50px;
}

:host(ids-loading-indicator[inline]:not([linear]):not([sticky])) {
  width: 11px;
  height: 11px;
}

:host(ids-loading-indicator[align=center]:not([linear]):not([sticky]):not([inline])) {
  position: fixed;
  inset-block-start: var(--ids-loading-indicator-offset-y, 50%);
  inset-inline-start: var(--ids-loading-indicator-offset-x, 50%);
  margin-block-start: -25px;
  margin-inline-start: -25px;
}

:host(ids-loading-indicator[align=center]:not([stopped])[contained]:not([sticky]):not([inline])) {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

:host(ids-loading-indicator[align=center]:not([stopped])[contained][x-offset]:not([sticky]):not([inline])) svg,
:host(ids-loading-indicator[align=center]:not([stopped])[contained][y-offset]:not([sticky]):not([inline])) svg {
  position: absolute;
  inset-block-start: var(--ids-loading-indicator-offset-y, 50%);
  inset-inline-start: var(--ids-loading-indicator-offset-x, 50%);
  margin-block-start: -25px;
  margin-inline-start: -25px;
}

:host(ids-loading-indicator[stopped]:not([linear]):not([sticky])),
:host(ids-loading-indicator[stopped][linear]),
:host(ids-loading-indicator[stopped][sticky]) {
  display: none;
}

:host(ids-loading-indicator[linear]),
:host(ids-loading-indicator[sticky]) {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

:host(ids-loading-indicator[sticky]) {
  position: absolute;
  align-items: center;
  top: 0;
  left: 0;
}

:host(ids-loading-indicator[linear]) {
  align-items: flex-end;
  height: 48px;
}

:host(ids-loading-indicator[overlay]) {
  z-index: var(--ids-z-index-top-level-container);
}

.progress {
  transition: stroke-dashoffset 0.275s ease-in, transform 0.275s ease-in;
  z-index: 1;
}

.progress-percentage {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 49%;
  transform: translate(-50%, -50%);
  color: var(--ids-loading-indicator-color-text);
}

.progress-percentage.linear {
  top: 50%;
}

.percentage {
  position: relative;
  top: -4px;
  right: -2px;
}

svg.linear-indicator {
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--ids-loading-indicator-height);
  overflow: hidden;
}
svg.linear-indicator.sticky {
  height: var(--ids-loading-indicator-height);
}
svg.linear-indicator .progress {
  fill: var(--ids-loading-indicator-progress-color, transparent);
  transform: scaleX(calc(var(--progress) * 1%));
}
svg.linear-indicator .circle {
  fill: var(--ids-loading-indicator-circle-color, transparent);
}

svg.circular-indicator {
  position: relative;
  overflow: visible;
  fill: var(--ids-color-transparent, transparent);
  transform-origin: 50% 50%;
  transform: rotateZ(-90deg);
  display: flex;
  align-items: center;
  justify-content: center;
}
svg.circular-indicator circle {
  transform-origin: 50% 50%;
}
svg.circular-indicator .circle {
  stroke: var(--ids-loading-indicator-circle-color, transparent);
}
svg.circular-indicator .progress {
  stroke-dasharray: 283;
  stroke: var(--ids-loading-indicator-progress-color, transparent);
}

svg.circular-indicator:not(.inline) {
  width: 50px;
  height: 50px;
}

svg.circular-indicator.inline {
  width: 11px;
  height: 11px;
}

.circular-indicator.determinate .progress {
  /*
   * circumference is 2πr(45) => 282.74, or 283
   */
  stroke-dashoffset: calc(283px - (var(--progress) * 2.83));
}

.ai-loading-indicator {
  display: flex;
  position: relative;
  width: 56px;
}

.ai-loading-indicator .bar {
  margin-right: 2px;
  margin-left: 2px;
  background-color: var(--ids-loading-indicator-ai-color-background-default, transparent);
  width: 16px;
  height: 8px;
  border-radius: 8px;
  transition: 0.2s;
  animation: loading 1.2s ease-in-out 0.2s infinite;
}

.ai-loading-indicator .bar:nth-child(1) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-one, transparent);
  animation-delay: 0s;
}

.ai-loading-indicator .bar:nth-child(2) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-two, transparent);
  animation-delay: 0.14s;
}

.ai-loading-indicator .bar:nth-child(3) {
  background-color: var(--ids-loading-indicator-ai-color-background-bar-three, transparent);
  animation-delay: 0.42s;
}

@keyframes indeterminate-spinner-progress-anim {
  0%, 15% {
    stroke-dashoffset: 272;
    transform: rotate(0);
  }
  60% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  65% {
    stroke-dashoffset: 80;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 272;
    transform: rotate(360deg);
  }
}
@keyframes indeterminate-spinner-anim {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
svg.circular-indicator.indeterminate .progress {
  animation: 1.52s linear infinite both indeterminate-spinner-progress-anim;
}

svg.circular-indicator.indeterminate {
  animation: 2.4s linear infinite indeterminate-spinner-anim;
}

svg.linear-indicator.indeterminate .progress {
  animation: 2.8s linear infinite both indeterminate-linear-progress-anim;
}

@keyframes indeterminate-linear-progress-anim {
  0% {
    transform: translateX(0%) scaleX(0.0001);
  }
  3.125%, 53.125% {
    transform: translateX(0%) scaleX(0.2);
  }
  6.25% {
    transform: translateX(20%) scaleX(0.3);
  }
  12.5%, 62.5% {
    transform: translateX(60%) scaleX(0.45);
  }
  25%, 75% {
    transform: translateX(100%) scaleX(1);
  }
  25.0001%, 50%, 75.0001%, 100% {
    transform: translateX(0%) scaleX(0.0001);
  }
}
@keyframes loading {
  0% {
    height: 8px;
  }
  50% {
    width: 56px;
  }
  100% {
    height: 8px;
  }
}
:host([size=xs]:not([linear]):not([sticky]):not([inline])), :host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(container) {
  width: 15px;
  height: 15px;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(circle) {
  stroke-width: 12;
}
:host([size=xs]:not([linear]):not([sticky]):not([inline]))::part(progress) {
  stroke-width: 21;
}

:host(.type-primary)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-circle-stroke, transparent);
}
:host(.type-primary)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-progress-color-border, transparent);
}

:host(.type-primary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-primary-destructive-progress-color-border, transparent);
}
:host(.type-primary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-primary-destructive-circle-stroke, transparent);
}

:host(.type-tertiary-destructive)::part(progress) {
  stroke: var(--ids-loading-indicator-destructive-progress-color-border, transparent);
}
:host(.type-tertiary-destructive)::part(circle) {
  stroke: var(--ids-loading-indicator-tertiary-destructive-circle-stroke, transparent);
}

ids-loading-indicator[contained][overlay] {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.loading-container {
  position: relative;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
